/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ChevronDownIcon({ className, size = 'xsmall' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "-2 -4 15 15" },
        jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.161.633l.678.734-5.386 4.976L.161 1.454.839.719l4.614 4.262z" })));
}
//# sourceMappingURL=ChevronDownIcon.js.map